import Pagination from './Pagination';
export default Pagination;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/pagination/index.js
// module id = 238
// module chunks = 14